import { createGlobalStyle } from 'styled-components';

import HelveticaNeueLTPro55Roman from './font/HelveticaNeueLTW01-55Roman.woff';
import HelveticaNeueLTPro75Bold from './font/HelveticaNeueLTW01-75Bold.woff';
import Montserratv23latinregular from './font/montserrat-v23-latin-regular.woff';

const GlobalStyle = createGlobalStyle`
  body {
    height: auto;
    margin: 0;
    padding: 0;
    font-family: 'Montserrat', serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5 {
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
    padding: 0;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
  border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: gray;
    border-radius: 5px;
  }

  @font-face {
    font-family: 'Helvetica Neue LT Pro 55 Roman';
    font-style: normal;
    font-weight: normal;
    src: local('Helvetica Neue LT Pro 55 Roman'),
    url(${HelveticaNeueLTPro55Roman}) format('woff');
  }

  @font-face {
    font-family: 'Helvetica Neue LT Pro 75 Bold';
    font-style: normal;
    font-weight: normal;
    src: local('Helvetica Neue LT Pro 75 Bold'),
    url(${HelveticaNeueLTPro75Bold}) format('woff');
  }

  @font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  src: local('Montserrat'),
  url(${Montserratv23latinregular}) format('woff'); 
}
  
`;

export default GlobalStyle;
